import React from 'react';
import { useTranslation } from 'react-i18next';
import { Report, ReportStatus } from '../../../types';
import StatusBadge from '../../StatusBadge/StatusBadge';
import { StatusFlowTooltip } from '../../StatusFlowTooltip';
import './ReportStatusInfo.css';

interface ReportStatusInfoProps {
  report: Report | null | undefined;
}

export const ReportStatusInfo: React.FC<ReportStatusInfoProps> = ({ report }) => {
  const { t } = useTranslation();

  if (!report) {
    return null;
  }

  return (
    <section className="sidebar-section report-status-info">
      <div className="section-header-with-tooltip">
        <h3>{t('reportForm.reportStatus')}</h3>
        <StatusFlowTooltip currentStatus={report.status as ReportStatus} />
      </div>
      <div className="status-display">
        <StatusBadge status={report.status as ReportStatus} />
      </div>
    </section>
  );
};

export default ReportStatusInfo;
